/* tslint:disable */
/* eslint-disable */
export enum BudgetVersionState {
  Draft = 'draft',
  Active = 'active',
  Past = 'past'
}
